export function ReactGit(){

    return(

        <>
        <h1>Hello Git </h1>
        </>
    )
}

export default ReactGit;